<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b2"><a id="part01"></a><a id="page_8"><strong>SECTION</strong><br/><span class="f2">ONE</span></a></h2><a id="page_8">
</a><h2 class="h2c"><a id="page_8"></a><a id="page_9">WHAT DID I JUST DRINK?<br/><span class="f3">A Guide to Beer Styles (and History!)</span></a></h2><a id="page_9">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?228b8aa6